var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.604 10.313c0 2.784 2.178 5.037 5.016 5.134a.874.874 0 0 1 .238 0h.076a5.133 5.133 0 0 0 4.962-5.134 5.15 5.15 0 0 0-5.146-5.146 5.15 5.15 0 0 0-5.146 5.146zM6.259 18.328c-1.376.92-2.135 2.167-2.135 3.5 0 1.332.759 2.567 2.124 3.477 1.516 1.018 3.51 1.527 5.503 1.527 1.993 0 3.987-.509 5.503-1.527 1.365-.921 2.124-2.156 2.124-3.5-.011-1.332-.759-2.567-2.124-3.477-3.022-2.015-7.951-2.015-10.995 0zM20.264 15.142H20.21c-.065 0-.13 0-.184.022-1.05.054-2.015-.282-2.74-.9a4.957 4.957 0 0 0 1.624-4.116 5.028 5.028 0 0 0-.834-2.362 3.892 3.892 0 0 1 5.58 3.163c.172 2.102-1.323 3.944-3.392 4.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.936 23.551c-1.084.596-2.449.878-3.803.845.78-.704 1.235-1.581 1.322-2.513.108-1.343-.531-2.633-1.81-3.662a8.943 8.943 0 0 0-2.491-1.365c2.394-.693 5.406-.227 7.258 1.268.997.801 1.506 1.809 1.409 2.849-.087 1.05-.759 1.96-1.885 2.578z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09);
export default __webpack_public_path__ + "static/media/icon-09.4a5192e584f46022b9091056f32174d9.svg";
export { ForwardRef as ReactComponent };